import React from 'react';
import './Welcome.css';

const Welcome = ({ adminData }) => {
  const name = adminData?.name || 'Admin';

  return (
    <div className="welcome-page">
      <div className="welcome-header">
        <div className="welcome-title">
          <h1>Welcome, {name}</h1>
          <p className="welcome-subtitle">Ecatcho dashboard</p>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
